<mat-form-field>
  <div class="flex">
    @if (required()) {
    <div class="jk-required-indicator">*</div>
    }
    <input type="text" [placeholder]="placeholder" matInput [formControl]="myControl" [ngStyle]="widthStyle"
      [matTooltip]="myTooltip" (change)="onValueChange($event)" [matAutocomplete]="auto"
      (keydown.enter)="onValueEnter($event)">
    <mat-autocomplete #auto="matAutocomplete">
      @for (option of filteredOptions | async; track option.idName) {
      <mat-option [value]="option.id">{{option.id}} {{option.name}} {{option.ps1}}</mat-option>
      }
    </mat-autocomplete>
  </div>
  <div class="jk-item-name-display">{{item.name}}</div>
</mat-form-field>